import { render } from "./CouponInfoTable.vue?vue&type=template&id=0cd3e3dc&scoped=true"
import script from "./CouponInfoTable.vue?vue&type=script&lang=js"
export * from "./CouponInfoTable.vue?vue&type=script&lang=js"

import "./CouponInfoTable.vue?vue&type=style&index=0&id=0cd3e3dc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd3e3dc"]])

export default __exports__